export const WRAPPER_OPEN_CUSTOM_EVENT = {
  ADD_FUNDING_SOURCE: 'AddFundingSource',
  ADD_BANK_CARD: 'AddBankCard',
  ADD_BANK_ACCOUNT: 'AddBankAccount',
  RELINK_BANK_ACCOUNT: 'RelinkBankAccount',
  ADD_PAYPAL: 'AddPaypalAccount',
  KYC: 'OpenKYCSidebar',
  EDIT_FUNDING_SOURCE: 'EditFundingSource',
  MANAGE_BACKUP_ACCOUNT: 'ManageBackupAccount',
  MANAGE_PRIMARY_ACCOUNT: 'ManagePrimaryAccount',
  REFER_A_FRIEND: 'ReferFriend',
  CHANGE_PIN: 'ChangePin',
  IN_HOUSE_LOGIN: 'InHouseLogin',
  MISSING_ADDRESS: 'MissingAddress',
  RETRY_TRANSACTION: 'RetryTransaction',
  PURCHASE_GIFT_CARD: 'GiftCardPurchase',
};

export const WRAPPER_HIDE_HEADER_EVENT = 'HideHeader';
